import React from 'react';
import { Routes, Route, NavLink, useLocation, Link } from 'react-router-dom';
import styled from 'styled-components';
import ColorMerge from './games/ColorMerge';
import Trivia from './games/Trivia';

const PageContainer = styled.div`
  margin: 0 auto;
`;

const SubNavigation = styled.nav`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1rem;
  padding-top: 1rem;

  @media (max-width: 480px) {
    flex-wrap: wrap;
    gap: 1.5rem;
    padding: 1rem;
    justify-content: space-around;
  }
`;

const SubNavLink = styled(NavLink)`
  text-decoration: none;
  color: #666;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 0.5rem 1rem;
  transition: all 0.3s ease;
  position: relative;
  white-space: nowrap;

  @media (max-width: 480px) {
    font-size: 0.9rem;
    padding: 0.8rem;
    flex: 0 1 auto;
    text-align: center;
    min-width: 120px;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: -1rem;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: transparent;
    transition: background-color 0.3s ease;

    @media (max-width: 480px) {
      bottom: -0.8rem;
    }
  }

  &.active {
    color: #333;
    
    &:after {
      background-color: #333;
    }
  }

  &:hover {
    color: #333;
  }
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 3rem;
  color: #333;
  font-family: 'Lora', serif;
  font-weight: 500;
`;

const GameTitle = styled.h2`
  color: #333;
  margin-bottom: 1rem;
  font-family: 'Lora', serif;
  font-size: 1.8rem;
  font-weight: 500;
`;

const GameDescription = styled.p`
  color: #666;
  margin-bottom: 1.5rem;
  font-family: 'EB Garamond', serif;
  font-size: 1.2rem;
  line-height: 1.6;
`;

const PlayButton = styled(Link)`
  display: inline-block;
  padding: 0.8rem 1.5rem;
  background: #333;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-family: 'EB Garamond', serif;
  font-size: 1.1rem;
  transition: background-color 0.2s;

  &:hover {
    background: #444;
  }
`;

const Games = () => {
  const location = useLocation();
  
  // Redirect to /games/color-merge if we're at exactly /games
  React.useEffect(() => {
    if (location.pathname === '/games') {
      window.location.href = '/games/color-merge';
    }
  }, [location]);

  return (
    <PageContainer>
      <SubNavigation>
        <SubNavLink to="/games/color-merge">Color Merge</SubNavLink>
        <SubNavLink to="/games/trivia">Trivia</SubNavLink>
      </SubNavigation>
      <Routes>
        <Route path="/color-merge/*" element={<ColorMerge />} />
        <Route path="/trivia" element={<Trivia />} />
      </Routes>
    </PageContainer>
  );
};

export default Games; 